import { render, staticRenderFns } from "./QuantidadePecas.vue?vue&type=template&id=6edab3d8&"
import script from "./QuantidadePecas.vue?vue&type=script&lang=js&"
export * from "./QuantidadePecas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports